module.exports = __webpack_public_path__ + "static/media/targaryen_token.69d89981.png";